import { AppUpdate } from '@capawesome/capacitor-app-update';

/**
 * Opens the app store for the user to update the app
 * This can be called from UI when showing an update prompt
 */
export async function openAppStoreForUpdate(): Promise<void> {
  try {
    await AppUpdate.openAppStore();
    console.log('[AppUpdate] Opened app store for update');
  } catch (error) {
    console.error('[AppUpdate] Failed to open app store:', error);
    throw error;
  }
}

/**
 * Checks if an app update is available
 * Returns true if an update is available in the store
 */
export function isAppUpdateAvailable(): boolean {
  return localStorage.getItem('appUpdateAvailable') === 'true';
}

/**
 * Gets the available app update version
 * Returns the version string or null if no update is available
 */
export function getAvailableAppUpdateVersion(): string | null {
  if (!isAppUpdateAvailable()) {
    return null;
  }
  return localStorage.getItem('appUpdateVersion');
}

/**
 * Clears the app update notification
 * Call this when the user dismisses the update prompt
 */
export function dismissAppUpdate(): void {
  localStorage.removeItem('appUpdateAvailable');
  localStorage.removeItem('appUpdateVersion');
}
